<template>
  <div>
    <div class="section-body">
      <FormSectionTitle
:cn-name="target.cnName"
:tooltip="target.tooltip"
/>
      <div class="setting-view2">
        <el-form
ref="form"
:model="initFormData"
label-width="80px"
>
          <template v-for="(item, index) in target.props">
            <!-- {{ item.key }}
             ---
             {{item.pid}} -->
            <div
              :key="index"
              v-bind="item.bind"
              class="config_item"
              :style="{
                'border-bottom': index == target.props.length - 1 ? 'none' : '1px solid #E9E9E9'
              }"
            >
              <FormTitle
v-if="item.bind.label"
:title="item.bind.label"
:tooltip="item.tooltip"
/>
              <renderCmp
v-if="item.render"
:render-f="item.render"
/>             
              <component
                :is="propsName(item)"
                v-if="item.type || item.cmpPath"
                :key="item.pid + index"
                :ref="item.type + index"
                v-model="initFormData[item.key]"
                :pid="item.pid"
                :element__this="item"
                :v_key="item.key"
                :target="target"
                v-bind="item.bind"
                v-on="item.on"
                @input="(e)=>item.set(e)"
              />
            </div>
          </template>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 第三方组件

import TmpStore from '@/view/weappTmp/core/lib/base/store.js'
import renderCmp from './renderCmp.vue'
import FormTitle from '@/view/weappTmp/comps/title/index.vue'
import FormSectionTitle from '@/view/weappTmp/comps/sectionTitle/index.vue'
export default {
  name: 'RenderProps',
  components: {
    renderCmp,
    FormTitle,
    FormSectionTitle
  },
  props: {
    res: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pedestalConfig: {
      type: Object
    }
  },
  data () {
    return {
      initFormData: {},
      target: {
        props: []
      }
    }
  },
  computed: {},
  created () {
    // console.log('RenderProps-created')
    this.init()
  },  
  mounted () {
    // console.log('RenderProps-mounted')
  },
  methods: {
    propsName: (item) => {
      if( typeof item.type == 'string' && item.type.length)return item.type
      else if (item.type) return item.type
      else {
        return require('@/weappTmps' + item.cmpPath).default
      }
    },
    init () {
      const _target = TmpStore.getVal('target')
      console.log('RenderProps',_target) 
      this.initFormData = _target.data
      this.target = _target     
    },    
  }
}
</script>

<style lang="scss">
@import '../../../index';

.config_item {
  border-bottom: 1px solid #e9e9e9;
  padding-bottom: 21px;
  margin-bottom: 21px;
  &_title {
    margin-bottom: 14px;
  }
}
</style>
